export const getState = (state) => state;

export default getState;
